import { useSendProviderUserInvite } from '@/queries/provider-permission-management/mutations'
import { ProviderUserRole } from '@/queries/provider-permission-management/schema'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shad/ui/dialog'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useSelector } from 'react-redux'
import ManageUserForm, { UserFormValues } from './manage-user-form'

interface CreateUserDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  providerId: string
  roles: ProviderUserRole[]
}

export default function CreateUserDialog({
  open,
  roles,
  onOpenChange,
  providerId,
}: CreateUserDialogProps) {
  const programId = useSelector(selectSelectedProgram).id
  const inviteUserMutation = useSendProviderUserInvite({
    programId,
    providerId,
  })

  const handleSubmit = (data: UserFormValues) => {
    inviteUserMutation.mutate(
      {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        roleId: data.role,
      },
      {
        onSuccess: () => {
          onOpenChange(false)
        },
      }
    )
  }

  const handleOpenChange = (newOpen: boolean) => {
    // Prevent closing the dialog when mutation is pending
    if (!newOpen && inviteUserMutation.status === 'pending') {
      return
    }
    onOpenChange(newOpen)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-lg"
        onInteractOutside={(e) => {
          if (inviteUserMutation.status === 'pending') {
            e.preventDefault()
          }
        }}
      >
        <DialogHeader>
          <DialogTitle>Invite New User</DialogTitle>
        </DialogHeader>

        <ManageUserForm
          defaultValues={undefined}
          onSubmit={handleSubmit}
          roles={roles}
          submitButtonText="Send Invite"
          mutationStatus={inviteUserMutation.status}
        />
      </DialogContent>
    </Dialog>
  )
}
